/**
 * Deutsche Formatierung für Datum, Zeit und Geldbeträge.
 * Datumsformat: TT.MM.JJJJ
 * Zahlen-/Geldformat: 1.234,56 €
 */

const dateFmt = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFmt = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const moneyFmt = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

const numberFmt = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** "10.05.2026" — akzeptiert Date oder ISO-String. */
export function formatDate(input: Date | string): string {
  const d = input instanceof Date ? input : new Date(input);
  return dateFmt.format(d);
}

/** "10.05.2026, 08:30" */
export function formatDateTime(input: Date | string): string {
  const d = input instanceof Date ? input : new Date(input);
  return dateTimeFmt.format(d);
}

/**
 * "1.234,56 €" — `null`/`undefined` (Phase G, Entscheidung #6: Lohn für
 * Filialleiter ohne `managerCanSeeWages` verborgen) ergibt "–", NICHT "0,00 €"
 * — sonst sähe es aus wie ein tatsächlicher Lohn von null statt "verborgen".
 */
export function formatMoney(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return '–';
  return moneyFmt.format(amount);
}

/** "1.234,56" — ohne Währung */
export function formatNumber(n: number): string {
  return numberFmt.format(n);
}

/** "08:00" → bleibt "08:00" (Schicht-Zeiten sind immer HH:MM-Strings). */
export function formatTime(hhmm: string): string {
  return hhmm;
}
